/* ═══════════════════════════════════════════════════════════════════════════
   What the business gets to see
   Ported unchanged from the prototype. This is the most important rule on the
   whole platform, which is why it sits here as a pure function with tests of
   its own — not inside a component where a refactoring could lose it.

   Two steps:
     1. Nothing is disclosed before the customer actually is a customer there.
     2. Even then the business gets only what its own job requires.
   ═══════════════════════════════════════════════════════════════════════ */

/* The three lists used to be kept here by hand, and the same three were kept
   again as constants in Avtale_disclosure.php. They are one thing, so they now
   come from the registry — one row per industry, one source of truth for the
   website, the API and this file. The names are unchanged because the tests
   and the backend both use them. */
export { AT_HOME, AGE18, AGE } from '../industries/index.js';
import { industry } from '../industries/index.js';

export function age(dateOfBirth, now = new Date()) {
  if (!dateOfBirth) return null;
  const f = new Date(dateOfBirth);
  if (isNaN(f)) return null;
  let a = now.getFullYear() - f.getFullYear();
  const m = now.getMonth() - f.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < f.getDate())) a--;
  return a;
}

/**
 * The fields the business gets. Returns null if the customer is not a
 * customer there.
 *
 * @param {object} customer      the account on the platform
 * @param {object} business      {id, industry}
 * @param {boolean} isCustomer   does the relation exist?
 */
export function disclosedTo(customer, business, isCustomer, now = new Date()) {
  if (!customer || !business) return null;
  if (!isCustomer) return null;

  const rule = industry(business.industry).disclosure;
  const out = {
    name: customer.name || '(not given)',
    phone: customer.phone,
  };
  if (customer.email) out.email = customer.email;

  if (rule.address && customer.address && customer.address.street) {
    out.address = [
      customer.address.street,
      [customer.address.postal_code, customer.address.city].filter(Boolean).join(' '),
    ].filter(Boolean).join(', ');
  }

  const a = age(customer.date_of_birth, now);
  if (rule.over18 && a != null) out['over 18'] = a >= 18 ? 'yes' : 'no';
  else if (rule.age && a != null) out['age'] = a + ' years';

  return out;
}

/**
 * The gate. A record can only be put in the customer's mirror if the relation
 * exists. It does not throw — it returns null, so the caller has to deal with
 * the fact that nothing happened.
 */
export function mayDisclose(customer, businessId, relations) {
  if (!customer || !businessId) return false;
  return (relations || []).some(r => r.businessId === businessId);
}
